export const REVIEW_PAGE_ITEM_COUNT = 10;
export const QNA_PAGE_ITEM_COUNT = 10;
export const COMMENT_PAGE_ITEM_COUNT = 10;
